import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { RootState } from 'store';

const useGetCurrentQuestionState = (questionId:any) => {
    const {drawPolygons} = useSelector((state:RootState)=>state.surveyJS);
    const [currentQuestion,setCurrentQuestion] = useState();

    useEffect(()=>{
        const currentQuestion = drawPolygons.find((s:any)=>s.id == questionId);
        setCurrentQuestion(currentQuestion);
        
      },[questionId,drawPolygons])

    return currentQuestion;
}

export { useGetCurrentQuestionState};